module.exports = __webpack_public_path__ + "static/media/tipologia13.f35a6fff.png";